<template>
  <div id="intro" :class="$mq" class="color-white txt-bold noselect">

    <!-- taustakuvat -->
    <!-- <div class="hero-custom-bg2" :style="{ backgroundImage: 'url(/hero/' + persaus + '.jpg)' }"></div> -->
    <transition name="bgswap">
      <div v-if="bgCounter === 1" key="jee1" class="hero-custom-bg" style="background-image: url(/hero/hero_2.jpg)"></div>
      <div v-else-if="bgCounter === 2" key="jee2" class="hero-custom-bg" style="background-image: url(/hero/hero_1.jpg)"></div>
      <div v-else-if="bgCounter === 3" key="jee3" class="hero-custom-bg" style="background-image: url(/hero/hero_4.jpg)"></div>
      <div v-else-if="bgCounter === 4" key="jee4" class="hero-custom-bg" style="background-image: url(/hero/hero_5.jpg)"></div>
      <div v-else-if="bgCounter === 5" key="jee5" class="hero-custom-bg" style="background-image: url(/hero/hero_6.jpg)"></div>
      <div v-else-if="bgCounter === 6" key="jee6" class="hero-custom-bg" style="background-image: url(/hero/hero_7.jpg)"></div>
      <div v-else-if="bgCounter === 7" key="jee7" class="hero-custom-bg" style="background-image: url(/hero/hero_8.jpg)"></div>
      <!-- <div v-else-if="bgCounter === 8" key="jee8" class="hero-custom-bg" style="background-image: url(/hero/hero_3.jpg)"></div> -->
    </transition>
    <!-- nyt kovakoodattu... muuta myöhemminn dynaamiseksi jos tarvis -->

    <div id="intro-info" class="absolute">
      <div class="h-full flex align-center" style="max-width: 950px; margin: 0 auto; padding: 0 40px;">
        <transition name="introswap" mode="out-in">
          <div v-if="counter === 1" key="i1" class="px-2 color-white" style="max-width: 400px;">
            <p style="font-size: 2.4rem">KETTERÄN ASUMISEN KEITTOKIRJA</p>
            <!-- <p>Ketterä - Työkalu hyvän asumisen suunnittelijoille ja kehittäjille</p> -->
            <button @click="$router.push({ name: 'aihe', params: { topic_id: 'mika-tama-sovellus-on?' } })" class="btn btn-1 mt-5 block" style="text-transform: initial !important;">Mikä keittokirja?</button>
          </div>
          <!-- <div v-else-if="counter === 2" key="i2" class="px-2 color-white" style="max-width: 400px;">
            <p>Tietopankki urbaanin asumisen suunnittelijoille ja kehittäjille</p>
            <button @click="$router.push({ name: 'aihe', params: { topic_id: 'asumisen-tarpeet' } })" class="btn btn-1 mt-5 block">Tarpeet</button>
          </div> -->
          <div v-else-if="counter === 2" key="i2" class="px-2 color-white" style="max-width: 400px;">
            <p style="font-size: 2.2rem">Tietopankki urbaanin asumisen suunnittelijoille ja kehittäjille</p>
            <!-- <p>Idea- ja tietopankki avaa tutkitun näkökulman ketterään asumiseen ajankohtaisten aiheiden, keinojen ja kohteiden avulla.</p> -->
            <button @click="$router.push('keinot')" class="btn btn-1 mt-5 mr-4">Keinot</button>
            <button @click="$router.push('kohteet')" class="btn btn-1 mt-5">Kohteet</button>
          </div>
        </transition>
      </div>
    </div>

    <!-- slide index display -->
    <ul>
      <!-- <li v-for="ind in inds" :key="ind" @click="counter = ind" :class="{ selected: ind === counter }"></li> -->
      <li v-for="ind in inds" :key="ind" :class="{ selected: ind === counter }"></li>
    </ul>

    <!-- swapperit -->
    <!-- <div class="swappers absolute tl-0 wh-full flex justify-between align-center pointer-events-none">
      <div @click="swapIntro('prev')" class="left absolute tl-0 h-full w-2 flex flex-center pointer-events-all pointer">
        <i class="material-icons noselect font-20">keyboard_arrow_left</i>
      </div>
      <div @click="swapIntro('next')" class="right absolute tr-0 h-full w-2 flex flex-center pointer-events-all pointer">
        <i class="material-icons noselect font-20">keyboard_arrow_right</i>
      </div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: 'intro',
  data () {
    return {
      windowWidth: 0,
      counter: 1,
      bgCounter: 1,
      inds: [1, 2] // tämä tällä hetkellä kovakoodattu (paska ratkaisu mutta ajaa tällä hetkellä asiansa -> muuta, jos myöhemmin tarvetta)
    }
  },

  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.$once('hook:destroyed', () => {
      window.removeEventListener('resize', this.handleResize)
    })
    this.changeHeroContent()
  },

  methods: {
    changeHeroContent () {
      let amountBgs = 7
      let amountTexts = 2
      let self = this
      setInterval(() => {
        // taustakuvat
        if (self.bgCounter >= amountBgs) {
          self.bgCounter = 1
        } else {
          self.bgCounter++
        }
        // tekstit
        if (self.counter >= amountTexts) {
          self.counter = 1
        } else {
          self.counter++
        }
      }, 3500)
    },

    handleResize () {
      this.windowWidth = window.innerWidth
    },

    changeIntro (data) {
      this.introState = data
    },

    swapIntro (data) {
      if (data === 'next') {
        if (this.counter >= 2) {
          this.counter = 1
        } else { this.counter++ }
      } else {
        if (this.counter <= 1) {
          this.counter = 2
        } else { this.counter-- }
      }
    }
  }
}
</script>

<style lang="scss">
#intro {
  position: relative;
  //top: -30px; // häki
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 65vh;
  max-height: 400px;
  margin-bottom: 2rem;
  //background: #2193b0;
  /* fallback for old browsers */
  //background: -webkit-linear-gradient(to right, #6dd5ed, #2193b0);
  /* Chrome 10-25, Safari 5.1-6 */
  //background: linear-gradient(to right, #6dd5ed, #2193b0);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  box-shadow: 0 1.5px 2px rgba(0, 0, 0, 0.2);
  & > div {
    position: absolute;
    top: 0; left: 0;
    height: 100%;
    width: 100%;
  }
  ul {
    position: absolute;
    top: 10px;
    //top: calc(100% - 30px);
    left: 50%;
    transform: translateX(-50%);
  }
  li {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 10px;
    border-radius: 50%;
    // border: 1.2px solid rgb(100, 100, 100);
    // border: 1px solid rgb(110, 110, 110);
    background-color: rgb(170, 170, 170);
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
    //cursor: pointer;
    &:last-child { margin-right: 0; }
    &.selected { background-color: white; }
  }
}

#intro-info {
  p {
    font-size: 2rem;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.6);
    font-weight: 900;
  }
  .phone & p { font-size: 1.4rem; }
  .tablet & p { font-size: 1.7rem; }
}

#intro1 {
  //background: #cc2b5e;  /* fallback for old browsers */
  //background: -webkit-linear-gradient(to right, #753a88, #cc2b5e);  /* Chrome 10-25, Safari 5.1-6 */
  //background: linear-gradient(to right, #753a88, #cc2b5e); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  img {
    //width: 300px;
    animation: movelens 3s infinite
  }
}
@keyframes movelens {
  0% { transform: scale(1.0, 1.0); }
  50% { transform: scale(1.15, 1.15); }
  100% { transform: scale(1.0, 1.0); }
}
#intro2 {
  //background: #e65c00;  /* fallback for old browsers */
  //background: -webkit-linear-gradient(to right, #F9D423, #e65c00);  /* Chrome 10-25, Safari 5.1-6 */
  //background: linear-gradient(to right, #F9D423, #e65c00); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
#intro3 {
  //background: #1488CC;  /* fallback for old browsers */
  //background: -webkit-linear-gradient(to right, #2B32B2, #1488CC);  /* Chrome 10-25, Safari 5.1-6 */
  //background: linear-gradient(to right, #2B32B2, #1488CC); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
/* #intro1, #intro2, #intro3 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
} */
.intro-content {
  width: calc(100% - 6rem);
  max-width: 1000px;
  height: calc(100% - 5rem);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  &.small {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .left *, .right * {
    align-self: stretch;
  }
}

.introanim-enter-active, .introanim-leave-active {
  transition: all 0.5s ease;
}
.introanim-enter, .introanim-leave-to {
  opacity: 0;
  transform: rotateY(90deg)
}

.swappers {
  & > div { background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)); }
  .left:hover { background: linear-gradient(to right, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0)); }
  .right:hover { background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.25)); }
}

.bgswap-enter {
  opacity: 0;
}
.bgswap-enter-active {
  transition: all 1s ease;
}
.bgswap-leave-active {
  transition: all 1s ease;
  opacity: 0;
}
.introswap-enter {
  opacity: 0;
}
.introswap-enter-active {
  transition: all 0.5s ease;
}
.introswap-leave-active {
  transition: all 0.5s ease;
  opacity: 0;
}
</style>
